export default __webpack_public_path__ + "static/media/silver.2fbdce2c.png";